const QuantitySelector = ({ value, onChange, min = 1, max = 99, size = 'md' }) => {
  const base = size === 'sm'
    ? 'flex shrink-0 items-center rounded-full border border-border overflow-hidden h-8'
    : 'flex shrink-0 items-center rounded-xl border border-border overflow-hidden';

  return (
    <div className={base}>
      <button
        onClick={() => onChange(Math.max(min, value - 1))}
        disabled={value <= min}
        className={`text-ink-soft hover:text-primary hover:bg-primary-light transition-all disabled:opacity-30
          ${size === 'sm' ? 'px-2.5 text-sm h-full' : 'px-3 py-2.5 text-base'}`}
      >
        −
      </button>
      <span
        className={`font-bold text-ink border-x border-border text-center select-none
          ${size === 'sm' ? 'px-3 text-sm min-w-[2rem]' : 'px-4 py-2 text-sm min-w-[3rem]'}`}
      >
        {value}
      </span>
      <button
        onClick={() => onChange(Math.min(max, value + 1))}
        disabled={value >= max}
        className={`text-ink-soft hover:text-primary hover:bg-primary-light transition-all disabled:opacity-30
          ${size === 'sm' ? 'px-2.5 text-sm h-full' : 'px-3 py-2.5 text-base'}`}
      >
        +
      </button>
    </div>
  );
};

export default QuantitySelector;
